import { notify } from './notifications'
import history from '../configureHistory'
import { messages } from './messages'
import { addBreadcrumb } from '../sentry-config'

// Actions
const RECEIVE_REMINDERS = 'reminders/recieve'
const REMOVE_REMINDER = 'reminders/remove'

export function receiveReminders(reminders) {
  return { type: RECEIVE_REMINDERS, payload: reminders }
}

export function removeReminder(id) {
  return { type: REMOVE_REMINDER, payload: id }
}

export default function reducer(state = [], { type, payload }) {
  switch (type) {
    case RECEIVE_REMINDERS:
      return payload
    case REMOVE_REMINDER:
      return state.filter(reminder => reminder.id !== payload)
    default:
      return state
  }
}

export const getReminders = () => (dispatch, getState, { gateway }) =>
  gateway.reminders
    .index()
    .then(reminders => dispatch(receiveReminders(reminders)))
    .catch(e => {
      addBreadcrumb({
        category: 'error',
        message: e.message || 'An error occurred',
        level: 'error',
        data: e,
      })
    })

export const completeReminder = id => async (dispatch, getState, { gateway }) => {
  await gateway.reminders.complete(id)
  dispatch(removeReminder(id))
  dispatch(notify(messages.textNotifyReminderCompleted))
}

export const createReminder = dueDate => async (dispatch, getState, { office, gateway }) => {
  const [subject, { emailAddress }] = await Promise.all([
    office.item.getSubject(),
    office.item.getInterlocutorDetails(),
  ])

  if (!emailAddress) {
    const errorMessage = messages.textErrorMessageReminderNotCreated
    dispatch(
      notify({
        type: 'error',
        message: errorMessage,
      })
    )
    throw new Error(errorMessage)
  }

  const body = {
    person_email: emailAddress,
    subject: subject || '',
    due_date: dueDate,
  }

  try {
    await gateway.reminders.create(body)
    dispatch(notify(messages.textNotifyReminderCreated))
    addBreadcrumb({ message: 'Reminder Has Been Created!', category: 'request' })
    history.push('/reminders')
  } catch (e) {
    captureException(e)
  }
}
